export default "__VITE_ASSET__DuLgFmFb__"